import { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import {
  getVoucherGroup,
  userCreateVoucherGroup,
} from "../actions/voucher/VoucherAction";
import "../assets/css/partnerPortal/voucher.scss";

interface Voucher {
  partner: string;
  voucherCode: string;
  firstName: string;
  lastName: string;
  email: string;
  expirationDate: Date;
  status: string;
}

interface VoucherGroup {
  id: string;
  partnerName: string;
  allocatedVouchers: number;
  availableVouchers: number;
  usedVouchers: number;
  vouchers: Voucher[];
}

function VoucherHeader() {
  const [voucherGroup, setVoucherGroup] = useState({} as VoucherGroup);
  const [partnerData, setPartnerData] = useState({} as any);

  // Listen for messages from the parent
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== process.env.REACT_APP_PORTAL_URL) return;
      console.log("Received from parent:", event.data);
      setPartnerData(event.data);

      // Send a message back to the parent
      if (event.source) {
        (event.source as Window)?.postMessage(
          "Hello from iframe",
          event.origin
        );
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const getVoucherGroupData = () => {
      console.log("partnerData test:", partnerData);
      if (partnerData.partner_id) {
        getVoucherGroup(partnerData.partner_id)
          .then((response) => {
            if ("data" in response) {
              console.log(response.data);
              setVoucherGroup(response.data as VoucherGroup);
            } else {
              console.error("Error response:", response);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };
    return getVoucherGroupData();
  }, [partnerData]);

  const handleSendVoucherRequest = () => {
    const requestData = {
      id: partnerData.partner_id,
      partnerName: partnerData.company_name,
      allocatedVouchers: 0, // Default value, update as needed
    };
    userCreateVoucherGroup(requestData)
      .then((response) => {
        if ("data" in response) {
          console.log(response.data);
          setVoucherGroup(response.data as VoucherGroup);
        } else {
          console.error("Error response:", response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Container className="p-5 voucher-header-wrapper" fluid>
      <Row className="mb-4">
        <Col>
          <h4 className="text-left">Voucher Allocation</h4>
          <h6>Your current voucher allocation and usage</h6>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col className="d-flex flex-column justify-content-start">
          <h5>Partner:</h5>
          <h5>Allocated Vouchers</h5>
          <h5>Available Vouchers</h5>
          <h5>Used Vouchers</h5>
        </Col>
        <Col className="d-flex flex-column justify-content-end text-right">
          <h6>
            {voucherGroup.partnerName
              ? voucherGroup.partnerName
              : partnerData.company_name}
          </h6>
          <h6>{voucherGroup.allocatedVouchers || 0}</h6>
          <h5>{voucherGroup.availableVouchers || 0}</h5>
          <h6>{voucherGroup.availableVouchers || 0}</h6>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col className="text-center">
          {voucherGroup && voucherGroup.allocatedVouchers > 0 ? null : (
            <Button onClick={handleSendVoucherRequest}>Request Vouchers</Button>
          )}
        </Col>
      </Row>
    </Container>
  );
}
export default VoucherHeader;
